import { Component, OnInit } from '@angular/core';
import { AssessmentAttempterService } from 'src/app/assessment-attempter.service';

export const ASSESSMENT_START_RULES = {
  header: 'Before you begin',
  subHeader: 'Please read the following instructions carefully before starting your assessment.',
  sections: [
    {
      title: 'Time & Structure',
      rules: [
        "You will have 60 minutes, in one sitting. The timer starts the moment you click 'Begin Assessment' and can't be paused.",
        'Each question has its own 2-minute timer. If it runs out, the question moves on automatically. Attempting more questions leads to a more precise result, so if you are done before the 2-minute timer, submit and move to the next question.'
      ]
    },
    {
      title: 'About the Questions',
      rules: [
        'Some questions will not have a right or wrong answer; just pick what feels most true to yourself.',
        'Read each question completely and properly first—some look harder than they actually are. For example, many seeming math questions might not require calculations.',
        'Select an option by clicking it. Click again to deselect and change your answer.'
      ]
    },
    {
      title: 'Important',
      rules: [
        'Keep a calculator, pen and paper handy.',
        'Please attempt this on your own, without outside help—it gives you the most accurate result.',
        'Camera access must remain active during the assessment to maintain assessment integrity.',
        "Once started, you can't exit and resume. Make sure you are ready before you click Attempt.",
        'Do not switch tabs, minimize the browser, or leave the assessment screen. Doing so will immediately end and fail the active attempt.',
        "If the assessment gets stuck, or the 'Progressing' screen does not move or reload after a minute, close the window and reach out to us."
      ]
    }
  ],
  supportEmail: 'talent@konvac.com'
};

@Component({
    selector: 'app-assessment-rules',
    templateUrl: './assessment-rules.component.html',
    styleUrls: ['./assessment-rules.component.css'],
    standalone: false
})
export class AssessmentRulesComponent implements OnInit {

  constructor(private attempterService:AssessmentAttempterService) { }

  rules: any = ASSESSMENT_START_RULES;


  ngOnInit(): void {
    this.attempterService.$rulesObject.subscribe((ruleDataStr)=>{
      if(ruleDataStr){
        this.rules = JSON.parse(ruleDataStr);
      }else{
        this.rules = ASSESSMENT_START_RULES;
      }
    })
  }

}
